import * as React from 'react'

export interface ISkodaNoConnectProps {
    title: string;
    text: string;
}

export class SkodaNoConnect extends React.Component<ISkodaNoConnectProps> {
    constructor(props: ISkodaNoConnectProps) {
        super(props);
    }

    render() {
        return (

            
            <div className="skoda-no-connect-content">
                    <h5>{this.props.title}</h5>
                    <p>{this.props.text}</p>
                </div>
           
        );
    }
}
